<template >
    <el-row class="alltext" :style="{height:all_height}">
      <el-col :offset="2" :span="20">
        <!-- <i class="el-icon-arrow-left" @click="back()" style="cursor: pointer;">返回</i> -->
        <h2 style="text-align: center;">发布考试</h2>
        <el-steps :active="set_page.active"  finish-status="success">
          <el-step title="选择人员"></el-step>
          <el-step title="设置考试时间及周期"></el-step>
          <el-step title="设置及格分数及不补考次数"></el-step>
          <el-step title="发布状态"></el-step>
        </el-steps>

        <el-row  v-if="set_page.active==0" style="margin-top: 1.25rem;">
          <el-row :style="{height:set_page.first_height}">
            <el-col :offset="1" :span="10" class="first_left">
              <el-row style="margin: 1.25rem;">
                <el-row style="float: right;">
                  <el-button type="danger" icon="el-icon-delete" circle @click="removeper()"></el-button>
                  <el-button type="success" icon="el-icon-check" circle @click="per_click"></el-button>
                </el-row>
                <el-input  style="margin-top: 9px;" v-model="user_value" placeholder="请输入内容"></el-input> <br />
                <div :style="{height:set_page.tree_height}" class="over_tree">
                  <el-tree
                       show-checkbox
                       :data="info.user_list"
                       ref="treeper"
                       node-key="num"
                       :filter-node-method="filterNode"
                       :default-checked-keys="setup.mr_xz_key"
                      :props="setup.defaultProps">
                  </el-tree>
                </div>
              </el-row>
            </el-col>
            <el-col :offset="2" :span="10" class="first_left">
              <el-row style="margin: 1.25rem;">
                <span>您选择的是</span>
                <span style="float: right;">共{{upload.xzper_list.length}}人</span>
                  <el-table
                      :data="upload.xzper_list"
                      style="width: 100%">
                      <el-table-column
                        prop="name"
                        label="姓名">
                      </el-table-column>
                    </el-table>
              </el-row>
            </el-col>
          </el-row>
            <el-button plain style="margin-top: 1.25rem;float: right;" @click="next('1')">下一步</el-button>
        </el-row>

        <el-row v-if="set_page.active==1" style="margin-top: 1.25rem;">
          <el-row>
            <el-input v-model="setup.item_input" placeholder="考试时间" style="width: 10%;"></el-input><span style="margin: 0 0.625rem;">(分钟)</span>
            <el-date-picker
              v-model="setup.data"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :picker-options="time_option"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <span style="margin-left: 1.25rem; ">是否可逾期考试（默认否）</span>
            <el-switch
              v-model="setup.overdue"
              >
            </el-switch>
            <span style="margin-left: 1.25rem;" >
              <el-button @click="cancel('time')">取消</el-button>
              <el-button type="primary"  @click="settings('time')">统一设置</el-button>
            </span>
          </el-row>
          <el-row v-if="upload.xzper_list.length==0">
            <el-empty description="暂无数据"></el-empty>
          </el-row>
          <el-table
          v-if="upload.xzper_list.length!=0"
            ref="multipleTable"
            :data="upload.xzper_list"
            tooltip-effect="dark"
            class="exam"
            border
            :height="set_page.first_height"
            :row-class-name="tableRowClassName"
            @cell-click="tabClick"
            :key="set_page.bomkey_file"
            >
            <el-table-column
              prop="name"
              label="姓名"
             >
            </el-table-column>
            <el-table-column
                  label="考试时间(分)"
                  width="180"
                  prop="time"
                  >
                  <template slot-scope="scope">
                    <span v-if="scope.row.index === set_page.tabClickIndex ">
                      <el-input v-model="scope.row.time"  placeholder="请输入时间" size="mini"  @blur="inputBlur(scope.row)"  />
                    </span>
                    <span v-else>{{scope.row.time }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                      label="开始时间~结束时间"
                      width="400">
                      <template slot-scope="scope">
                        <el-date-picker
                        v-if="set_page.time_tabClick"
                          v-model="scope.row.data"
                          :picker-options="time_option"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                        </el-date-picker>
                        <el-date-picker
                        v-if="!set_page.time_tabClick"
                          v-model="scope.row.data"
                          type="daterange"
                          readonly
                          :picker-options="time_option"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                        </el-date-picker>
                      </template>
                    </el-table-column>
                    <el-table-column
                          label="是否可[逾期考试]（默认否）"
                          width="180"
                          >
                          <template slot-scope="scope">
                            <el-switch
                            v-if="set_page.time_tabClick"
                              v-model="scope.row.overdue">
                            </el-switch>
                            <el-switch
                            v-if="!set_page.time_tabClick"
                             disabled
                              v-model="scope.row.overdue">
                            </el-switch>
                          </template>
                    </el-table-column>
                <el-table-column
                      label="操作"
                      width="100">
                      <template slot-scope="scope">
                        <el-button @click="delete_user(scope.row)"  type="text" size="small" style="color: red;">删除</el-button>
                      </template>
                    </el-table-column>
          </el-table>
          <el-row style="margin-top: 1.25rem;float: right;">
            <el-button plain  @click="next('0')">上一步</el-button>
            <el-button plain  @click="next('2')">下一步</el-button>
          </el-row>
        </el-row>


        <el-row v-if="set_page.active==2" style="margin-top: 1.25rem;">
          <el-row>
            <el-input v-model="setup.passing_grade" placeholder="及格分" style="width: 10%;"></el-input>
            <el-select  v-model="setup.exam_num" style="width: 10%;" placeholder="补考次数">
                <el-option
                  v-for="item in set_page.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

            <el-button @click="cancel('passing_grade')">取消</el-button>
            <el-button type="primary" style="margin-bottom: 0.625rem;" @click="settings('passing_grade')">统一设置</el-button>
          </el-row>
          <el-row v-if="upload.xzper_list.length==0">
            <el-empty description="暂无数据"></el-empty>
          </el-row>
          <el-table
          v-if="upload.xzper_list.length!=0"
            ref="multipleTable"
            :data="upload.xzper_list"
            tooltip-effect="dark"
            class="exam"
            border
            :height="set_page.first_height"
            :row-class-name="tableRowClassName_pass"
            @cell-click="tabClick_pass"
            :key="set_page.bomkey_pass"
            >
            <el-table-column
              prop="name"
              label="姓名"
             >
            </el-table-column>
            <el-table-column
                  label="考试时间(分)"
                  width="180"
                  prop="time"
                  >
                  <template slot-scope="scope">
                    <span>{{scope.row.time }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                      label="开始时间~结束时间"
                      width="400">
                      <template slot-scope="scope">
                        <el-date-picker
                          v-model="scope.row.data"
                          type="daterange"
                          readonly
                          :picker-options="time_option"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                        </el-date-picker>
                      </template>
                    </el-table-column>
                    <el-table-column
                          label="是否可[逾期考试]"
                          width="180"
                          >
                          <template slot-scope="scope">
                            <el-switch
                             disabled
                              v-model="scope.row.overdue">
                            </el-switch>
                          </template>
                    </el-table-column>
                    <el-table-column
                          label="及格分(100分满分)"
                          width="180"
                          prop="passing_grade"
                          >
                          <template slot-scope="scope">
                            <span v-if="scope.row.index === set_page.tabClickIndex_pass ">
                              <el-input v-model="scope.row.passing_grade"  placeholder="请输入及格分" size="mini"  @blur="inputBlur_pass(scope.row)"  />
                            </span>
                            <span v-else>{{scope.row.passing_grade}}</span>
                          </template>
                        </el-table-column>
                     <el-table-column
                           label="补考次数"
                           width="180"
                           prop="exam_num"
                           >
                           <template slot-scope="scope">
                             <el-select v-if="set_page.exam_num_tabClick" v-model="scope.row.exam_num" placeholder="补考次数">
                                 <el-option
                                   v-for="item in set_page.options"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                                 </el-option>
                               </el-select>
                            <el-select disabled  v-if="!set_page.exam_num_tabClick" v-model="scope.row.exam_num" placeholder="请选择">
                                <el-option
                                  v-for="item in set_page.options"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                              </el-select>
                           </template>
                     </el-table-column>
                    <el-table-column
                      label="操作"
                      width="100">
                      <template slot-scope="scope">
                        <el-button @click="delete_user(scope.row)"  type="text" size="small" style="color: red;">删除</el-button>
                      </template>
                    </el-table-column>
          </el-table>
          <el-row style="margin-top: 1.25rem;float: right;">
          <el-button plain  @click="next('1')">上一步</el-button>
          <el-button plain  @click="next('3')">发布</el-button>
          </el-row>
        </el-row>

        <el-row v-if="set_page.active==3" style="margin-top: 1.25rem;">
          <el-row v-if="result_list_show.length==0">
            <el-empty description="暂无数据"></el-empty>
          </el-row>
          <el-table
          v-if="result_list_show.length!=0"
            ref="multipleTable"
            :data="result_list_show"
            tooltip-effect="dark"
            class="exam"
            border
            :height="set_page.first_height"
            :key="set_page.bomkey_all"
             :default-sort = "{prop: 'status',}"
            >
            <el-table-column
              prop="name"
              label="姓名"
             >
            </el-table-column>
            <el-table-column
              label="状态"
              width="180"
              prop="status"
              sortable
              >
              <template slot-scope="scope">
                <span v-if="scope.row.status" >成功</span>
                <span v-else style="color: red">失败</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-button @click="again(scope.row)"  type="text" size="small" style="color: red;"  v-if="!scope.row.status" >重新发送</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-row style="margin-top: 1.25rem;float: right;">
          <el-button plain    @click="next('4')">完成</el-button>
          </el-row>
        </el-row>
        <el-dialog
          title="注意"
          :visible.sync="set_page.time_dialogVisible"
          width="30%"
          >
          <span>统一设置之后不可更改</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="set_page.time_dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="time_dialogVisible()">确 定</el-button>
          </span>
        </el-dialog>
      </el-col>

    </el-row>
</template>

<script>
  export default{
    watch: {
         user_value(val){
           // 根据关键词过滤
           this.$refs.treeper.filter(val);
         },
       },
    data(){
      return{
        result_list_show:[],
        page_id:'',
        result_list:{
          num:this.$route.query.num,
          companyee:[]
        },
        time_option: {
          disabledDate(time) {
              return time.getTime() < Date.now() -8.64e7;
          },
        },
        all_height:'',
        user_value:'',
        set_page:{
          tree_height:'',
          type_show:'first',
          first_height:'',
          active:0,
          tabClickIndex:'',
          bomkey_file:'',
          tabClickIndex_pass:'',
          bomkey_pass:'',
          bomkey_all:'',
          pass_tabClick:true,
          time_tabClick:true,
          exam_num_tabClick:true,
          time_dialogVisible:false,
          options:[{
             value: '1',
              label: '1'
          },
          {
             value: '2',
              label: '2'
          },

          {
             value: '3',
              label: '3'
          },
          {
             value: '4',
              label: '4'
          },
          {
             value: '5',
              label: '5'
          },]
        },
        info:{
          num:this.$route.query.num,
          user_list:[]
        },
        upload:{
          xzper_list:[],//选择人员
        },
        setup:{
          overdue:false,
          defaultProps: {
            children: 'children',
            label: 'name',
          },
          item_input:'',
          data:'',
          passing_grade:'',
          exam_num:'',
        }
      }
    },
    mounted() {
      // this.$message.error(this.info.num);
      this.all_height=window.innerHeight  + 'px'
      this.set_page.first_height=window.innerHeight *0.6  + 'px'
      this.set_page.tree_height=window.innerHeight *0.6 - 150 + 'px'
      this.get_info()
    },
    methods:{
      back(){
        this.$router.push({path:'/eva_list'});
      },
      again(item){
        let _this=this
        let data={
          num:_this.info.num,
          push:_this.page_id,
          companyee:[{
            num:item.num
          }]
        }
        _this.axios.post('/v2/c_evaluate/company_exam_push',{data:data}
        ).then(function(res) {
          for(let i=0;i<_this.result_list_show.length;i++){
            if(_this.result_list_show[i].num==item.num){
              if(res.data.code==1){
                _this.result_list_show[i].status=true
              }
            }
          }
          _this.set_page.bomkey_all++
          })
      },
      get_info(){
        let _this = this;
        _this.axios.get("/v2/c_train/get_train_companyee_list").then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.info.user_list=res.data.data
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      removeper(){
        let _this=this;
        _this.upload.xzper_list=[];
         _this.$nextTick(function () {
                //Dom更新完毕
                this.$refs.treeper.setCheckedKeys([]);
              });
      },
      per_click() {
        let a=this.$refs.treeper.getCheckedNodes();
        this.upload.xzper_list=[];
        let j=0;
        for(let i=0;i<a.length;i++){
          if(a[i].hasOwnProperty('s_id')){
            this.$set(this.upload.xzper_list,j,a[i])
            j++;
          }
        }
        this.upload.xzper_list=this.unique(this.upload.xzper_list)
      },
      unique(arr) {
       const res = new Map();
       return arr.filter((arr) => !res.has(arr.num) && res.set(arr.num, 1));
      },
      settings(type){
          this.set_page.time_dialogVisible=true
      },
      cancel(type){
        if(type=='time'){
          this.set_page.time_tabClick=true
          for(let i=0;i<this.upload.xzper_list.length;i++){
            this.$delete(this.upload.xzper_list[i],'time')
            this.$delete(this.upload.xzper_list[i],'data')
            this.$delete(this.upload.xzper_list[i],'overdue')
          }
          this.set_page.bomkey_file++
        }else{
          this.set_page.pass_tabClick=true
          this.set_page.exam_num_tabClick=true
          for(let i=0;i<this.upload.xzper_list.length;i++){
            this.$delete(this.upload.xzper_list[i],'passing_grade')
            this.$delete(this.upload.xzper_list[i],'exam_num')
          }
          this.set_page.bomkey_pass++
        }
      },
      time_dialogVisible(){
        this.set_page.time_dialogVisible=false
        if(this.set_page.active==1){
          if(this.setup.item_input!=0){
            for(let i=0;i<this.upload.xzper_list.length;i++){
              this.upload.xzper_list[i]['time']=this.setup.item_input
            }
            this.set_page.time_tabClick=false
          }
          if(this.setup.data!=''){
            for(let i=0;i<this.upload.xzper_list.length;i++){
              this.upload.xzper_list[i]['data']=this.setup.data
            }
          }
            for(let i=0;i<this.upload.xzper_list.length;i++){
              this.upload.xzper_list[i]['overdue']=this.setup.overdue
            }
          this.set_page.bomkey_file++
        }else if(this.set_page.active==2){
          if(this.setup.passing_grade!=0){
            for(let i=0;i<this.upload.xzper_list.length;i++){
              this.upload.xzper_list[i]['passing_grade']=this.setup.passing_grade
            }
            this.set_page.bomkey_pass++
            this.set_page.pass_tabClick=false
          }

          if(this.setup.exam_num!=''){
            for(let i=0;i<this.upload.xzper_list.length;i++){
              this.upload.xzper_list[i]['exam_num']=this.setup.exam_num
            }
            this.set_page.exam_num_tabClick=false
          }
        }
      },
      next(type){
        let _this=this
        if(type=='1'){
          if(this.upload.xzper_list.length==0){
            _this.$message.error('人员不可为空');
          }else{
            _this.set_page.active=1
          }

        }else if(type=='0'){
          _this.set_page.active=0
          if(this.upload.xzper_list.length !=0){
            let list=[];
            for(let i=0;i<this.upload.xzper_list.length;i++){
               list.push(this.upload.xzper_list[i].num);
            }
            this.$nextTick(function () {
                   //Dom更新完毕
                   this.$refs.treeper.setCheckedKeys(list);
                 });
          }
        }else if(type=='2'){
          _this.set_page.active=2

        }else if(type=='3'){
          for(let i=0;i<_this.upload.xzper_list.length;i++){
            if(_this.upload.xzper_list[i].time!=undefined && _this.upload.xzper_list[i].data!=undefined && _this.upload.xzper_list[i].passing_grade!=undefined){
              if(_this.upload.xzper_list[i].time!='' && _this.upload.xzper_list[i].data!='' && _this.upload.xzper_list[i].passing_grade!=''){

                if(_this.upload.xzper_list[i].passing_grade>100){
                  _this.$message.error("及格分不能超过100");
                  return
                }else{
                  if(_this.upload.xzper_list.length-1==i){
                    for(let j=0;j<_this.upload.xzper_list.length;j++){
                      if(_this.upload.xzper_list[j].overdue==undefined ){
                        _this.upload.xzper_list[j].overdue==false
                      }
                      if(_this.upload.xzper_list[j].exam_num==undefined ){
                        _this.upload.xzper_list[j].exam_num=1
                      }
                        _this.up_data(_this.upload.xzper_list[j],j)
                    }
                  }
              }
              }else{
                _this.$message.error("时间、及格分、周期不能为空");
                return
              }
            }else{
              _this.$message.error("时间、及格分、周期不能为空");
              return
            }
          }
        }else if(type=='4'){
          // _this.set_page.btn_dialogVisible=true
          _this.back()

        }

      },
      up_data(item,i){
        let _this=this
           let data={
                  num:item.num,
                  score:item.passing_grade,
                  exam_num:item.exam_num,
                  s_time:item.data[0],
                  e_time:item.data[1],
                  exam_time:item.time,
                  overdue:item.overdue
                }
            _this.result_list.companyee.push(data)
            if(_this.upload.xzper_list.length-1==i){
             _this.axios.post('/v2/c_evaluate/company_exam_push',{data:_this.result_list}
             ).then(function(res) {
               if(res.data.code=='1'){
                 _this.page_id=res.data.data
                 _this.check_company_exam_push( _this.page_id)
                 _this.set_page.active=3
               }else{
                 _this.$message.error("发布失败，请重新发送");
               }
             })
            }
      },
      check_company_exam_push(num){
        let _this=this
        _this.axios.get('/v2/c_evaluate/check_company_exam_push',{params: {num:num}}
        ).then(function(res) {
          console.log(res)
          if(res.data.code=='1'){
            _this.result_list_show=res.data.data
          }
        })
      },
      tableRowClassName ({ row, rowIndex }) {
            row.index = rowIndex
      },
      tabClick (row, column, cell, event) {
        if(this.set_page.time_tabClick){
          this.set_page.tabClickIndex = row.index
          this.tabClickLabel = column.label
        }

      },
      inputBlur (row) {
            this.set_page.tabClickIndex_pass = null
            this.tabClickLabel_pass = ''
      },
      tableRowClassName_pass ({ row, rowIndex }) {
            row.index = rowIndex
      },
      tabClick_pass (row, column, cell, event) {
        if(this.set_page.pass_tabClick){
          this.set_page.tabClickIndex_pass = row.index
          this.tabClickLabel_pass = column.label
        }

      },
      inputBlur_pass (row) {
            this.set_page.tabClickIndex_pass = null
            this.tabClickLabel_pass = ''
      },
      delete_user(val){
        let _this=this
          for(let j=0;j<_this.upload.xzper_list.length;j++){
            if(val.num==_this.upload.xzper_list[j].num){
              _this.upload.xzper_list.splice(j,1)
          }
        }
      },
      filterNode(value, data) {
        if (!value) return true;
         return data.name.indexOf(value) !== -1;
           },
    },
  }
</script>

<style scoped>
  .first_left{
    overflow-x: auto;
    border:1px solid 	#9D9D9D;
    border-radius: 5%;
    height: 100%;
    margin-top: 1.25rem;
  }
  .fenye{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.625rem;
  }
  .alltext{
    background-color: white;
  }
  .right{
     border: 2px solid red;
     border-radius: 5px;
     width: 100%;
  }
  .exam{
    overflow-x: auto;
  }
  .over_tree{
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/evaluate/test_paper/release.vue